import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import productsListStorage from "../../storages/productsListStorage";
import shoppingCartStorage from "../../storages/shoppingCartStorage";
import device from "../../helpers/deviceDetect";
import ArrowRightIcon from "../../assets/SvgIcons/ArrowRightIcon";
import ArrowLeftIcon from "../../assets/SvgIcons/ArrowLeftIcon";
import ArrowBigLeftIcon from "../../assets/SvgIcons/ArrowBigLeftIcon";
import ArrowBigRightIcon from "../../assets/SvgIcons/ArrowBigRightIcon";

function Pagination({ t }) {
  const history = useHistory();
  const [page, setPage] = useState(null);
  useEffect(() => {
    if (productsListStorage.currentPage + 1 !== page) {
      setPage(productsListStorage.currentPage + 1);
    }
  }, [productsListStorage.currentPage]);

  const allowFirst = productsListStorage.currentPage > 0;
  const allowBackOnePage = productsListStorage.currentPage > 0;
  const allowBackTwoPages = productsListStorage.currentPage > 1;
  const allowBackThreePages = productsListStorage.currentPage > 2;
  const allowNextOnePage =
    (productsListStorage.currentPage + 1) * productsListStorage.pageSize <
    productsListStorage.total;
  const allowNextTwoPage =
    (productsListStorage.currentPage + 2) * productsListStorage.pageSize <
    productsListStorage.total;
  const allowNextThreePage =
    (productsListStorage.currentPage + 3) * productsListStorage.pageSize <
    productsListStorage.total;
  const allowLastPage =
    productsListStorage.total / productsListStorage.pageSize > 1;
  const allowSelectionPage =
    productsListStorage.total !== 0 &&
    productsListStorage.total / productsListStorage.pageSize > 1;
  let timeoutId;
  const debounceTime = 300;

  function onPageChange(e) {
    const prevValue = productsListStorage.currentPage + 1;
    const currentValue = productsListStorage.selectedPage(+e.target.value);
    setPage(currentValue + 1);
    if (prevValue != +e.target.value) {
      if (currentValue > 0) {
        history.push(`?page=${currentValue + 1}`);
      } else {
        history.push(window.location.pathname);
      }
    }
  }

  return (
    <div
      data-js-collection-pagination
      data-pagination-type="button_load_more"
      data-js-collection-replace="pagination"
    >
      <div className="pagination">
        <div className="d-flex justify-content-center mt-35 mb-45">
          {productsListStorage.currentPage > 0 && (
            <Link
              to={window.location.pathname}
              className="btn btn--secondary mr-2 d-none d-md-flex"
              onClick={() => {
                productsListStorage.firstPage();
                setPage(productsListStorage.currentPage + 1);
              }}
            >
              <span>{t("FIRST PAGE")}</span>
            </Link>
          )}
          {allowBackOnePage && (
            <Link
              to={
                productsListStorage.currentPage > 1
                  ? `?page=${productsListStorage.currentPage}`
                  : window.location.pathname
              }
              className="btn mr-2 d-sm-flex d-md-none"
              onClick={() => {
                productsListStorage.goToPage(productsListStorage.currentPage);
                setPage(productsListStorage.currentPage);
              }}
            >
              <ArrowBigLeftIcon />
            </Link>
          )}

          {allowBackThreePages && (
            <Link
              to={
                productsListStorage.currentPage - 2 > 1
                  ? `?page=${productsListStorage.currentPage - 2}`
                  : window.location.pathname
              }
              className="btn btn--secondary mr-2 d-none d-md-flex"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage - 2
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              <span>{productsListStorage.currentPage - 2}</span>
            </Link>
          )}
          {allowBackTwoPages && (
            <Link
              to={
                productsListStorage.currentPage - 1 > 1
                  ? `?page=${productsListStorage.currentPage - 1}`
                  : window.location.pathname
              }
              className="btn btn--secondary mr-2"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage - 1
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              <span>{productsListStorage.currentPage - 1}</span>
            </Link>
          )}
          {allowBackOnePage && (
            <Link
              to={
                productsListStorage.currentPage > 1
                  ? `?page=${productsListStorage.currentPage}`
                  : window.location.pathname
              }
              className="btn btn--secondary"
              onClick={() => {
                productsListStorage.goToPage(productsListStorage.currentPage);
                setPage(productsListStorage.currentPage);
              }}
            >
              <span>{productsListStorage.currentPage}</span>
            </Link>
          )}
          {allowSelectionPage && (
            <div>
              <input
                type="number"
                value={page || productsListStorage.currentPage + 1}
                onInput={(e) => {
                  setPage(e.target.value);
                }}
                className="btn h-100 mb-0 mr-2 ml-2"
                style={{ width: "70px" }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    onPageChange(e);
                  }
                }}
                onBlur={onPageChange}
                min="1"
              />
            </div>
          )}
          {allowNextOnePage && (
            <Link
              to={`?page=${productsListStorage.currentPage + 2}`}
              className="btn btn--secondary mr-2"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage + 2
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              {productsListStorage.currentPage + 2}
            </Link>
          )}
          {allowNextTwoPage && (
            <Link
              to={`?page=${productsListStorage.currentPage + 3}`}
              className="btn btn--secondary mr-2"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage + 3
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              {productsListStorage.currentPage + 3}
            </Link>
          )}
          {allowNextThreePage && (
            <Link
              to={`?page=${productsListStorage.currentPage + 4}`}
              className="btn btn--secondary mr-2 d-none d-md-flex"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage + 4
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              {productsListStorage.currentPage + 4}
            </Link>
          )}
          {allowLastPage && (
            <Link
              to={`?page=${Math.ceil(
                productsListStorage.total / productsListStorage.pageSize
              )}`}
              className="btn btn--secondary mr-2"
              onClick={() => productsListStorage.lastPage()}
            >
              {t("LAST PAGE")}
            </Link>
          )}
          {allowNextOnePage && (
            <Link
              to={`?page=${productsListStorage.currentPage + 2}`}
              className="btn mr-2 d-sm-flex d-md-none"
              onClick={() => {
                productsListStorage.goToPage(
                  productsListStorage.currentPage + 2
                );
                setPage(productsListStorage.currentPage);
              }}
            >
              <ArrowBigRightIcon />
            </Link>
          )}
        </div>
      </div>
      <input type="hidden" name="page" value="1" />
    </div>
  );
}

Pagination.propTypes = {};

export default withTranslation()(observer(Pagination));
